import { inject } from '@angular/core';
import { HttpRequest, HttpInterceptorFn } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { DataExchangeService } from '../services/session/data-exchange.service';
import { SharedService } from '../services/shared.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const dataExchangeService = inject(DataExchangeService);
  const sharedService = inject(SharedService);

  // Use basic authentication to obtain a temporary auth token
  if (req.url.includes('/auth/api/token')) {
    return next(req);
  }
  // Use temporary auth token to retrieve session details, including a permanent auth token
  if (req.url.includes('/ui-pages/payload/session')) {
    const tempToken = dataExchangeService.tempToken();
    return next(tempToken ? addTokenHeader(req, tempToken) : req);
  }
  // Use permanent auth token for all other requests
  const authToken = dataExchangeService.authToken();
  return next(authToken ? addTokenHeader(req, authToken) : req).pipe(
    catchError(sharedService.handleError)
  );
};

function addTokenHeader(request: HttpRequest<unknown>, token: string) {
  return request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + token) });
}
